import { render, staticRenderFns } from "./backgrounds.vue?vue&type=template&id=0ae96471&scoped=true&"
import script from "./backgrounds.vue?vue&type=script&lang=js&"
export * from "./backgrounds.vue?vue&type=script&lang=js&"
import style0 from "./backgrounds.vue?vue&type=style&index=0&id=0ae96471&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae96471",
  null
  
)

export default component.exports